import { render, staticRenderFns } from "./Ipfs.vue?vue&type=template&id=7fbd4c86&"
import script from "./Ipfs.vue?vue&type=script&lang=js&"
export * from "./Ipfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports